// extracted by mini-css-extract-plugin
module.exports = {"lazyImg":"lazyImage_lazyImg__1JZ0l"};